import script from "./HomeViewSampleReport.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeViewSampleReport.vue?vue&type=script&setup=true&lang=js"

import "./HomeViewSampleReport.vue?vue&type=style&index=0&id=60c2e3ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c2e3ec"]])

export default __exports__